import React, { useEffect, useState } from "react";
import { Box, Grid, Stack, Typography } from "@mui/material";
import BackButton from "../workshop/components/BackButton";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import AssessmentIcon from "@mui/icons-material/Assessment";
import { useTranslation } from "react-i18next";
import StatCard from "../../shared/components/StatCard";
import { STAT_CARDS, VIEW_TABS } from "./utils";
import ViewTab from "../../shared/components/ViewTab";
import WorkshopsList from "./components/WorkshopsList";
import ReservationsList from "./components/ReservationsList";
import ServicesList from "./components/ServicesList";
import { useDispatch, useSelector } from "react-redux";
import { selectAdminStatCounts, setAdminStatCounts } from "../../app/store/dashboardSlice";
import { useGetAllBaseServicesQuery, useGetAllWorkshopsQuery } from "../../app/store/api/workshopApi";
import { useGetAllReservationsCountQuery } from "../../app/store/api/reservationApi";

const AdminPage = () => {
  const { t } = useTranslation();
  const [tab, setTab] = useState("workshops");
  const { data: workshopsList, isLoading: workshopsLoading } = useGetAllWorkshopsQuery();
  const { data: servicesList, isLoading: servicesLoading } = useGetAllBaseServicesQuery();
  const { data: reservationsCount } = useGetAllReservationsCountQuery();

  const dispatch = useDispatch();

  const statCounts = useSelector(selectAdminStatCounts);

  useEffect(() => {
    dispatch(setAdminStatCounts({ key: "workshops", value: workshopsList?.length || 0 }));
  }, [workshopsList]);

  useEffect(() => {
    dispatch(setAdminStatCounts({ key: "services", value: servicesList?.length || 0 }));
  }, [servicesList]);

  useEffect(() => {
    dispatch(setAdminStatCounts({ key: "reservations", value: reservationsCount || 0 }));
  }, [reservationsCount]);

  return (
    <Box sx={{ bgcolor: "#F4F6F9", minHeight: "100vh", width: "100%", pb: 6 }}>
      <Box sx={{ bgcolor: "#003C59", px: { xs: 2, md: 5 }, pt: 3, pb: 3, width: "100%" }}>
        <Stack direction='row' justifyContent='space-between' alignItems='flex-start'>
          <Box>
            <BackButton />
            <Stack direction='row' spacing={1.5} alignItems='center'>
              <Box
                sx={{
                  bgcolor: "#00C9DB",
                  width: 40,
                  height: 40,
                  borderRadius: 1.5,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <AssessmentIcon sx={{ color: "#003C59", fontSize: 20 }} />
              </Box>
              <Box>
                <Typography variant='h5' sx={{ color: "#fff", fontWeight: 700, lineHeight: 1.2 }}>
                  {t("adminDashboard.title")}
                </Typography>
                <Typography variant='body2' sx={{ color: "rgba(255,255,255,0.6)" }}>
                  {t("adminDashboard.description")}
                </Typography>
              </Box>
            </Stack>
          </Box>

          {/* <Badge badgeContent={2} color='error'>
            <IconButton sx={{ bgcolor: "rgba(255,255,255,0.06)", color: "#fff" }}>
              <NotificationsNoneOutlinedIcon />
            </IconButton>
          </Badge> */}
        </Stack>

        <Grid container spacing={2} sx={{ mt: 3, display: "flex", flexWrap: "wrap", justifyContent: "space-between", flexGrow: 1 }}>
          {STAT_CARDS.map((c) => (
            <StatCard key={c.key} label={t(`adminDashboard.${c.key}`)} value={statCounts[c.key]} Icon={c.icon} emphasize={c.emphasize} />
          ))}
        </Grid>
      </Box>

      <Box sx={{ px: { xs: 2, md: 5 }, mt: 3, width: "100%" }}>
        <Grid container spacing={1} sx={{ mb: 3, flexWrap: "wrap" }}>
          {VIEW_TABS.map((tabItem) => (
            <ViewTab key={tabItem.key} active={tab === tabItem.key} icon={tabItem.icon} label={t(`adminDashboard.${tabItem.key}`)} onClick={() => setTab(tabItem.key)} />
          ))}
        </Grid>

        {tab === "workshops" && <WorkshopsList workshopsList={workshopsList} isLoading={workshopsLoading} />}
        {tab === "reservations" && <ReservationsList />}
        {tab === "services" && <ServicesList servicesList={servicesList} isLoading={servicesLoading} />}
      </Box>
    </Box>
  );
};

export default AdminPage;
